// テストを「ゴールから」開いたかどうかを、テストごとにこのタブの中で覚えておく。
// ゴールから来たテストは、受験中・結果・結果の問題の画面の「戻る」をゴールへ向ける。
// テスト一覧（/classroom/exam-list/:examId/）から開き直したら忘れる（その場合の戻り先はテスト一覧）。
export interface ExamGoalContext {
  userGoalId: string
  goalName?: string
}

const key = (examId: string | number) => `examGoalContext:${examId}`

export function rememberExamGoal(examId: string | number, userGoalId: string | number, goalName?: string) {
  try {
    const prev = examGoalContext(examId)
    const name = goalName || (prev && prev.userGoalId === String(userGoalId) ? prev.goalName : undefined)
    sessionStorage.setItem(key(examId), JSON.stringify({ userGoalId: String(userGoalId), goalName: name }))
  } catch { /* 保存できない環境では、今までどおりの戻り先 */ }
}

export function forgetExamGoal(examId: string | number) {
  try { sessionStorage.removeItem(key(examId)) } catch { /* noop */ }
}

export function examGoalContext(examId: string | number | undefined | null): ExamGoalContext | null {
  if (examId === undefined || examId === null || examId === '') return null
  try {
    const raw = sessionStorage.getItem(key(examId))
    const data = raw ? JSON.parse(raw) : null
    return data && data.userGoalId ? data : null
  } catch {
    return null
  }
}

export function goalPath(context: ExamGoalContext) {
  return `/classroom/user-goals/${context.userGoalId}/`
}
